import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { Component } from 'react';
import { U as UIDContext } from './UIDContext-DaboSTJ1.js';
import { v as validateUidCharSafe } from './validateUidCharSafe-fddCu4jj.js';

/*
  Memoizing createPrefixer prevents redundant calls up the react tree.
 */
function createMemoizedPrefixer() {
  let lastParentPrefixer;
  let lastPrefix;
  let lastPrefixer;
  return function createPrefixer(parentPrefixer, prefix) {
    if (lastPrefixer === undefined || parentPrefixer !== lastParentPrefixer || prefix !== lastPrefix) {
      lastParentPrefixer = parentPrefixer;
      lastPrefix = prefix;
      lastPrefixer = function prefixer(suffix) {
        return parentPrefixer(`${prefix}:${suffix}`);
      };
    }
    return lastPrefixer;
  };
}
class UIDPrefix extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "prefixer", createMemoizedPrefixer());
  }
  render() {
    const {
      children,
      value
    } = this.props;
    const validatedValue = validateUidCharSafe(value, 'UIDPrefix');
    return /*#__PURE__*/React__default.createElement(UIDContext.Consumer, null, parentPrefixer => /*#__PURE__*/React__default.createElement(UIDContext.Provider, {
      value: this.prefixer(parentPrefixer, validatedValue)
    }, children));
  }
}

export { UIDPrefix as U };
//# sourceMappingURL=UIDPrefix-DBbZKd1f.js.map
